import * as React from 'react';
export default (
  <svg height="18" viewBox="0 0 15 18" width="15">
    <path
      d="m6.825.14234957-5.83333333 2.56641834c-.6.26406877-.99166667.85822349-.99166667 1.51014326v3.87851003c0 4.5799427 3.2 8.862808 7.5 9.9025788 4.3-1.0397708 7.5-5.3226361 7.5-9.9025788v-3.87851003c0-.65191977-.3916667-1.24607449-.9916667-1.51014326l-5.8333333-2.56641834c-.425-.18979943-.925-.18979943-1.35 0z"
      fill="#fff"
    />
  </svg>
);
